import { render, staticRenderFns } from "./weightAnalysis.vue?vue&type=template&id=26b4e8f4&scoped=true"
import script from "./weightAnalysis.vue?vue&type=script&lang=js"
export * from "./weightAnalysis.vue?vue&type=script&lang=js"
import style0 from "./weightAnalysis.vue?vue&type=style&index=0&id=26b4e8f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b4e8f4",
  null
  
)

export default component.exports